/**
 * This file was @generated using pocketbase-typegen
 */

import type PocketBase from 'pocketbase';
import type { RecordService } from 'pocketbase';

export enum Collections {
  Authorigins = '_authOrigins',
  Externalauths = '_externalAuths',
  Mfas = '_mfas',
  Otps = '_otps',
  Superusers = '_superusers',
  Inventory = 'inventory',
  InventoryCategories = 'inventory_categories',
  Users = 'users',
}

// Alias types for improved usability
export type IsoDateString = string;
export type RecordIdString = string;
export type HTMLString = string;

// System fields
export type BaseSystemFields<T = never> = {
  id: RecordIdString;
  collectionId: string;
  collectionName: Collections;
  expand?: T;
};

export type AuthSystemFields<T = never> = {
  email: string;
  emailVisibility: boolean;
  username: string;
  verified: boolean;
} & BaseSystemFields<T>;

// Record types for each collection

export type AuthoriginsRecord = {
  collectionRef: string;
  created?: IsoDateString;
  fingerprint: string;
  id: string;
  recordRef: string;
  updated?: IsoDateString;
};

export type ExternalauthsRecord = {
  collectionRef: string;
  created?: IsoDateString;
  id: string;
  provider: string;
  providerId: string;
  recordRef: string;
  updated?: IsoDateString;
};

export type MfasRecord = {
  collectionRef: string;
  created?: IsoDateString;
  id: string;
  method: string;
  recordRef: string;
  updated?: IsoDateString;
};

export type OtpsRecord = {
  collectionRef: string;
  created?: IsoDateString;
  id: string;
  password: string;
  recordRef: string;
  sentTo?: string;
  updated?: IsoDateString;
};

export type SuperusersRecord = {
  created?: IsoDateString;
  email: string;
  emailVisibility?: boolean;
  id: string;
  password: string;
  tokenKey: string;
  updated?: IsoDateString;
  verified?: boolean;
};

export enum InventoryPurchasePriceCurrencyOptions {
  'ILS' = 'ILS',
  'USD' = 'USD',
  'EUR' = 'EUR',
  'GBP' = 'GBP',
}

export enum InventoryEstimatedSellingPriceCurrencyOptions {
  'ILS' = 'ILS',
  'USD' = 'USD',
  'EUR' = 'EUR',
  'GBP' = 'GBP',
}

export enum InventorySellingPriceCurrencyOptions {
  'ILS' = 'ILS',
  'USD' = 'USD',
  'EUR' = 'EUR',
  'GBP' = 'GBP',
}
export type InventoryRecord = {
  RFID?: string;
  arrival_date?: IsoDateString;
  catalog_number?: string;
  categories?: RecordIdString[];
  comments?: string;
  comments_rich?: HTMLString;
  created?: IsoDateString;
  created_by?: RecordIdString;
  deleted_by?: RecordIdString;
  estimated_selling_price?: number;
  estimated_selling_price_currency?: InventoryEstimatedSellingPriceCurrencyOptions;
  id: string;
  image?: string;
  location?: string;
  manufacturer?: string;
  model?: string;
  original_catalog_number?: string;
  product_name?: string;
  purchase_price?: number;
  purchase_price_currency?: InventoryPurchasePriceCurrencyOptions;
  quantity?: number;
  selling_price?: number;
  selling_price_currency?: InventorySellingPriceCurrencyOptions;
  serial_number?: string;
  updated?: IsoDateString;
  updated_by?: RecordIdString;
};

export type InventoryCategoriesRecord = {
  created?: IsoDateString;
  id: string;
  name: string;
  updated?: IsoDateString;
};

export type UsersRecord = {
  avatar?: string;
  created?: IsoDateString;
  email: string;
  emailVisibility?: boolean;
  id: string;
  name?: string;
  password: string;
  tokenKey: string;
  updated?: IsoDateString;
  verified?: boolean;
};

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> =
  Required<AuthoriginsRecord> & BaseSystemFields<Texpand>;
export type ExternalauthsResponse<Texpand = unknown> =
  Required<ExternalauthsRecord> & BaseSystemFields<Texpand>;
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> &
  BaseSystemFields<Texpand>;
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> &
  BaseSystemFields<Texpand>;
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> &
  AuthSystemFields<Texpand>;
export type InventoryResponse<Texpand = unknown> = Required<InventoryRecord> &
  BaseSystemFields<Texpand>;
export type InventoryCategoriesResponse<Texpand = unknown> =
  Required<InventoryCategoriesRecord> & BaseSystemFields<Texpand>;
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> &
  AuthSystemFields<Texpand>;

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
  _authOrigins: AuthoriginsRecord;
  _externalAuths: ExternalauthsRecord;
  _mfas: MfasRecord;
  _otps: OtpsRecord;
  _superusers: SuperusersRecord;
  inventory: InventoryRecord;
  inventory_categories: InventoryCategoriesRecord;
  users: UsersRecord;
};

export type CollectionResponses = {
  _authOrigins: AuthoriginsResponse;
  _externalAuths: ExternalauthsResponse;
  _mfas: MfasResponse;
  _otps: OtpsResponse;
  _superusers: SuperusersResponse;
  inventory: InventoryResponse;
  inventory_categories: InventoryCategoriesResponse;
  users: UsersResponse;
};

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = PocketBase & {
  collection(idOrName: '_authOrigins'): RecordService<AuthoriginsResponse>;
  collection(idOrName: '_externalAuths'): RecordService<ExternalauthsResponse>;
  collection(idOrName: '_mfas'): RecordService<MfasResponse>;
  collection(idOrName: '_otps'): RecordService<OtpsResponse>;
  collection(idOrName: '_superusers'): RecordService<SuperusersResponse>;
  collection(idOrName: 'inventory'): RecordService<InventoryResponse>;
  collection(
    idOrName: 'inventory_categories'
  ): RecordService<InventoryCategoriesResponse>;
  collection(idOrName: 'users'): RecordService<UsersResponse>;
};
